<template>
  <div class="layout-blog-posts">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-blog-posts {
}
.container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px 30px;
}
@media screen and (max-width: 767px) {
  .container {
    grid-template-columns: 1fr;
    padding: 0 15px;
  }
}
</style>
